import { environment } from 'src/environments/environment';
import { Field } from './field';
import { Parcel } from './parcel';

export class SoilAnalysisDoc {
  // Name of the document. NB it also contains the extension of the file
  name: string = null;
  // The key that identifies the document in the S3 bucket and used for the PreSigned API
  key: string = null;
  file?: File = null;
  newDoc?: boolean = false;
}

export class SoilAnalysisProp {
  propId: any = null;
  unitId: any = null;
  amount: number = null;
  propTranslationKey?: string = null;
  // adding param to set the prop as disabled (used in the media analysis and new sampling point)
  disabled?: boolean = false;
}

export class SoilAnalysisSamplingPoint {
  lat: number = null;
  lng: number = null;
}
export class SoilAnalysis {
  id?: string;
  name?: string = null;
  companyId: number = null;
  field: Pick<Field, 'id'> = { id: null };
  parcel?: Pick<Parcel, 'id'> = { id: null };
  analysisDate: string = null;
  lastUpdated: string = null;
  dateCreated: string = null;
  deleted: boolean = null;
  soilUrl: string = null;
  granulometry: string = null;
  sandPercentage: number = null;
  slimePercentage: number = null;
  clayPercentage: number = null;
  soilTypeId: string = null;
  pH: number = null;
  analysisProps: SoilAnalysisProp[] = [];
  samplingPoint: SoilAnalysisSamplingPoint = null;
  filesUrl: string[] = [];
  // Holds the list of Files - in byte format - that are attached to the soil analysis
  documents?: SoilAnalysisDoc[] = [];
  // Identifies a group of soil analysis that are registered together
  uuid?: string = null;
  // Used to identify if the soil analysis is a media out of several soil analysis linked by the same uuid
  isMediaAnalysis?: boolean = false;
  shallowSoilType?: boolean = false;
}

// Class that holds the data of a group of soil analyses
// NB a group of soil analyses is a set of soil analyses that are registered together
export class SoilAnalysisGroupData {
  id: string = null;
  // The field by which the soil analyses are grouped (either "uuid" or "id") - nb ID is used when creating a second sampling point
  groupedBy: string = null;
  // The date shared by the analyses
  analysesDate: string = null;
  // The name shared by the analyses
  analysesName: string = null;
  // The status of the group of soil analyses
  status: string = null; //? (currently always "available", but it would be extended once GreenField service is implemented)
  // The field ID on which the analyses are collected
  fieldId: number = null;
  // The parcel ID on which the analyses are collected
  parcelId: number = null;
  companyId: number = null;
}

export class SoilAnalysesGroup {
  groupData: SoilAnalysisGroupData = new SoilAnalysisGroupData();
  analyses: SoilAnalysis[] = [];
}

// Response from the server when requesting a pre-signed URL for a file upload/download
export interface PreSignedResponse {
  preSignedMap: {
    [key: string]: string; // A map where the key is a string (e.g., "2876" - that is the SoilAnalysis Id) and the value is also a string (e.g., "urlString").
  };
}

export const GRANULOMETRIES = {
  SAND: 'sand',
  LOAMY_SAND: 'loamy_sand',
  LOAM: 'loam',
  SANDY_LOAM: 'sandy_loam',
  SLIT: 'slit',
  SILT_LOAM: 'silt_loam',
  SANDY_CLAY_LOAM: 'sandy_clay_loam',
  CLAY_LOAM: 'clay_loam',
  SILTY_CLAY_LOAM: 'silty_clay_loam',
  SANDY_CLAY: 'sandy_clay',
  SILTY_CLAY: 'silty_clay',
  CLAY: 'clay',
};

export const SOILANALISYSPLACEHOLDERS = {
  IMAGE_REQUEST_SERVICE: environment.publicAssetsUrl + 'sustainability/soil-analysis-cta.jpeg',
};

export const SAMPLINGPOINTMARKERSCOLORS = [
  '--p-red-400',
  '--p-sky-400',
  '--p-caco-400',
  '--p-grass-400',
  '--p-plum-200',
  '--p-sky-400',
  '--p-sea-400',
  '--p-coral-400',
  '--p-wine-400',
  '--p-ocean-400',
  '--p-plum-400',
  '--p-lime-400',
  '--p-coral-200',
  '--p-curry-200',
  '--p-plum-400',
  '--p-cherry-400',
  '--p-cacao-400',
  '--p-kiwi-400',
  '--p-curry-400',
  '--p-coal-400',
  '--p-cement-400',
];
